import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { AuthTokenResponse } from './use-create-customer';

type Variables = {
  userId: string;
  identityToken: string;
  fullName?: string;
  referralCode?: string;
  promoCode?: string;
};

export const useLoginCustomerApple = createMutation<
  AuthTokenResponse,
  Variables,
  AxiosError
>({
  mutationFn: async ({
    userId,
    identityToken,
    fullName,
    referralCode,
    promoCode,
  }) =>
    client({
      url: 'v2/login/apple',
      method: 'POST',
      data: {
        apple_credentials: {
          user_id: userId,
          identity_token: identityToken,
          first_name: fullName ? fullName.split(' ')[0] : '',
          last_name: fullName ? fullName.split(' ')[1] : '',
        },
        referral_code: referralCode,
        promo_code: promoCode,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
